"use strict";
exports.__esModule = true;
exports.chart_color_cyan_200 = {
  "name": "--pf-chart-color-cyan-200",
  "value": "#73c5c5",
  "var": "var(--pf-chart-color-cyan-200, #73c5c5)"
};
exports["default"] = exports.chart_color_cyan_200;